import { APP_URL } from "@/lib/constants";

export const Footer = () => (
  <footer data-testid="main-footer" className="pt-20 pb-10" style={{ background: "var(--ink)", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
    <div className="pw-container">
      <div className="grid md:grid-cols-4 gap-12 pb-16">
        <div className="md:col-span-2">
          <div className="text-white font-bold tracking-[0.28em] text-[15px] uppercase">Angiolini</div>
          <p className="mt-5 text-white/45 text-[14px] leading-relaxed max-w-xs">
            Клуб привилегий Angiolini — итальянская верхняя одежда, бонусы и
            персональный сервис.
          </p>
          <p className="mt-4 text-white/45 text-[14px]">Алматы, Нурлы Тау</p>
          <p className="mt-2 text-white/45 text-[14px]">Адрес бутика ТЦ"Jurek Tau", этаж P1.</p>
          <p className="mt-1 text-white/45 text-[14px]">
            Телефон:{" "}
            <a href="tel:+77018017755" data-testid="footer-phone-link" className="hover:text-white transition-colors duration-300">
              +7 701 801 77 55
            </a>
          </p>
        </div>
        <div>
          <div className="text-[11px] font-semibold tracking-[0.18em] uppercase text-white/40 mb-5">Разделы</div>
          <ul className="space-y-3">
            {[
              ["Возможности", "/#features"],
              ["ИИ-примерка", "/#fitting"],
              ["Привилегии", "/#benefits"],
              ["FAQ", "/#faq"],
              ["Статьи", "/articles"],
            ].map(([label, href]) => (
              <li key={href}>
                <a href={href} className="text-[14px] text-white/65 hover:text-white transition-colors duration-300">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-[11px] font-semibold tracking-[0.18em] uppercase text-white/40 mb-5">Связаться</div>
          <ul className="space-y-3">
            <li>
              <a
                href={APP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-app-link"
                className="text-[14px] text-white/65 hover:text-white transition-colors duration-300"
              >
                Приложение
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/angiolini_it"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="text-[14px] text-white/65 hover:text-white transition-colors duration-300"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href="https://wa.me/77018017755?text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="text-[14px] text-white/65 hover:text-white transition-colors duration-300"
              >
                WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4" style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        <span className="text-[13px] text-white/35">© 2026 Angiolini. Все права защищены.</span>
        <span className="text-[13px] text-white/35">hello@angiolini.kz</span>
      </div>
    </div>
  </footer>
);
